import { render, staticRenderFns } from "./SignLawsuit.vue?vue&type=template&id=09107277&scoped=true"
import script from "./SignLawsuit.vue?vue&type=script&lang=js"
export * from "./SignLawsuit.vue?vue&type=script&lang=js"
import style0 from "./SignLawsuit.vue?vue&type=style&index=0&id=09107277&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09107277",
  null
  
)

export default component.exports